import { useState, useEffect } from 'react';

export const usePosition = (calendarRef) => {
  const [ pos, setPos ] = useState('test');

  useEffect(() => {
    let bounding = calendarRef.current.getBoundingClientRect();
    if(bounding.right > (document.documentElement.clientWidth)) {
      setPos('right');
    } else {
      setPos('left');
    }
  }, []);

  return pos;
};
